<template>

  <el-row>
    <el-col :span="24">
      <l-map
        :zoom="zoomLevel"
        :center="center"
        :options="mapOptions"
        :style="'height: ' + this.height + '; width: ' + this.width + ';'"
        @update:center="centerUpdate"
        @update:zoom="zoomUpdate">

        <l-tile-layer
        :url="url"
        :attribution="attribution" />

        <l-marker v-if="captionStyle === 'tooltip' && caption" :lat-lng="center">
          <l-tooltip :options="{ permanent: true, interactive: true, direction: this.tooltipDir }">
            <div @click="mapClick">
              {{caption}}
            </div>
          </l-tooltip>
        </l-marker>
        <l-marker v-else :lat-lng="center">
          <l-popup v-if="caption">
            <div @click="mapClick">
              {{caption}}
            </div>
          </l-popup>
        </l-marker>

      </l-map>

  </el-col>

</el-row>

</template>

<script>
import { latLng } from 'leaflet'
import { LMap, LTileLayer, LMarker, LPopup, LTooltip } from 'vue2-leaflet'

export default {
  name: 'leaflet-map',

  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LTooltip
  },

  props: {
    lat: {
      type: Number,
      required: true
    },

    lng: {
      type: Number,
      required: true
    },

    height: {
      type: [Number, String],
      default: '17vh'
    },

    width: {
      type: [Number, String],
      default: '100%'
    },

    id: {
      type: [Number, String],
      default: null
    },

    caption: {
      type: String,
      default: null
    },
// right, left, top, bottom, center, auto
    tooltipDir: {
      type: String,
      default: 'right'
    },

    captionStyle: {
      type: String,
      default: 'tooltip'
    },

    callback: {
      type: Function,
      default: null
    },

    zoom: {
      type: Number,
      default: 11.5
    },

    draggable: {
      type: Boolean,
      default: true
    },

    allowZoom: {
      type: Boolean,
      default: true
    },

    topoMap: {
      type: Boolean,
      default: false
    }

  },


  methods: {

    zoomUpdate (zoom) {
      if (this.allowZoom) {
        this.currentZoom = zoom
      }
    },

    centerUpdate (center) {
      if (this.allowZoom) {
        this.currentCenter = center
      }
    },

    mapClick () {
      if (this.callback) {
        this.callback(this.id, this.caption, this.lat, this.lng)
      }
    }
  },

  data () {

    return {
      zoomLevel: this.zoom,
      center: latLng(this.lat, this.lng),

      url: this.topoMap ? 'https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png' : 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution:
      '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',

      currentZoom: 11.5,
      currentCenter: latLng(this.lat, this.lng),

      mapOptions: {
        zoomSnap: 0.5,
        dragging: this.draggable,
        zoomControl: this.allowZoom,
        scrollWheelZoom: this.allowZoom
      }
    }

  }


}
</script>
